import {Type} from 'class-transformer';

export class ForecastRevision {
    public readonly id!: string;
    public readonly quantity!: number;
    public readonly user!: string;

    @Type(() => Date)
    public readonly created!: Date;
}
